export enum ViewType {
  GRID = 'grid',
  KANBAN = 'kanban',
  CALENDAR = 'calendar',
  CHART = 'chart',
  TREE = 'tree',
  LIST = 'list',
  CARDS = 'cards',
}

export type ChartType = 'bar' | 'line' | 'scatter' | 'bubble' | 'pie' | 'doughnut' | 'polarArea' | 'radar' | undefined;

export type ChartTypeExtended = 'gen' | 'area' | 'column' | 'horizontalBar' | ChartType;

export const ChartType: Record<Uppercase<ChartTypeExtended>, ChartTypeExtended> = {
  PIE: 'pie',
  LINE: 'line',
  SCATTER: 'scatter',
  BUBBLE: 'bubble',
  POLARAREA: 'polarArea',
  RADAR: 'radar',
  BAR: 'bar',
  DOUGHNUT: 'doughnut',
  GEN: 'gen',
  AREA: 'area',
  COLUMN: 'column',
  HORIZONTALBAR: 'horizontalBar',
} as const;
